const customMediaQuery = (maxWidth) => `@media (max-width: ${maxWidth}px)`;
const sizes = {
    medium: 801,
    small: 410,
};
export const media = {
    custom: customMediaQuery,
    medium: customMediaQuery(sizes.medium),
    small: customMediaQuery(sizes.small),
    sizes,
};
export const lightTheme = {
    color: {
        background: "#fff",
        backgroundHover: "rgba(116,127,141,0.08)",
        backgroundAccent: "rgba(6,6,7,0.08)",
        backgroundAside: "#ebedef",
        backgroundBrand: "var(--chat-primary, #818181)",
        backgroundHoverAside: "#fff",
        backgroundIcon: "#808080",
        backgroundReaction: "#ebedef",
        backgroundReactionSelected: "#e8f5fb",
        backgroundReactionHover: "#fff",
        backgroundReply: "#ebedef",
        borderReactionHover: "#cfcfcf",
        borderReactionSelected: "#439cd1",
        cancelButtonColor: "#090B0B",
        cancelButtonBgColor: "#A0A6AC",
        cancelButtonHover: "#5a6268",
        deleteButtonColor: "#fff",
        deleteButtonBgColor: "#AD0000",
        text: "#2e3338",
        textMuted: "#747f8d",
        inputBackground: "#ebedef",
        headerTextColor: "#060607",
        scrollbar: "#bcbdbf",
        elevation: "rgba(29, 28, 29, 0.13) 0px 0px 0px 1px, rgba(0, 0, 0, 0.12) 0px 4px 12px 0px",
        danger: "red",
        anchor: "var(--chat-primary-anchor, #7397b7)",
        anchorMuted: "var(--chat-primary-anchor, #79b3e6)",
        badge: "#d6d7d9",
    },
};
export const darkTheme = {
    color: {
        background: "#1A1D21",
        backgroundHover: "#222529",
        backgroundAccent: "#4f545c",
        backgroundAside: "#222529",
        backgroundHoverAside: "#1a1d21",
        backgroundBrand: "var(--chat-primary, #818181)",
        backgroundIcon: "#818181",
        backgroundReaction: "#222529",
        backgroundReactionSelected: "#1D64A3",
        backgroundReactionHover: "#1A1D21",
        backgroundReply: "#444648",
        borderReactionHover: "#a19c9c",
        borderReactionSelected: "#1D64A3",
        cancelButtonColor: "#090B0B",
        cancelButtonBgColor: "#A0A6AC",
        deleteButtonColor: "#fff",
        deleteButtonBgColor: "#AD0000",
        cancelButtonHover: "#5a6268",
        text: "#d1d2d3",
        textMuted: "#ababad",
        inputBackground: "#222529",
        headerTextColor: "#d1d2d3",
        scrollbar: "#797c7e",
        elevation: "rgba(232, 232, 232, 0.13) 0px 0px 0px 1px, rgba(0, 0, 0, 0.12) 0px 4px 12px 0px",
        danger: "#FE4042",
        anchor: "var(--chat-primary-anchor, #439cd1)",
        anchorMuted: "var(--chat-primary-anchor, #79b3e6)",
        badge: "#373d46",
    },
};
//# sourceMappingURL=themes.js.map